import {
  CreateImporterProcessDocument,
  CreateImporterProcessMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'

export interface StartImporterProcessError {
  type?: string
  message?: string
  flash?: boolean
}

interface StartImporterProcessParams {
  variables: CreateImporterProcessMutationVariables
  onFail: (error: StartImporterProcessError) => void
  onSuccess: ({ importerProcessUuid }: { importerProcessUuid: string | null }) => void
}

export const useStartImporterProcess = () => {
  const [createImporterProcess, { loading, error }] = useMutation(CreateImporterProcessDocument, {
    extractorFn: (data) => data.importersMutations.createImportersImporterProcess,
  })

  const startImporterProcess = async ({
    variables,
    onFail,
    onSuccess,
  }: StartImporterProcessParams) => {
    const result = await createImporterProcess({
      variables,
    })

    const handled = handleResult(result, () => undefined)
    if (handled.success) {
      onSuccess({ importerProcessUuid: handled.data?.importerProcess?.uuid || null })
    } else {
      if (handled.errors[0]?.__typename === 'SimpleError') {
        onFail({ flash: true })

        return
      }

      if (handled.errors[0]?.__typename === 'StructuredError') {
        onFail({
          type: handled.errors[0].messages[1] || '',
          message: handled.errors[0].messages[0] || '',
        })

        return
      }
    }
  }

  return {
    loading,
    startImporterProcess,
  }
}
